module.exports = __webpack_public_path__ + "static/media/career-image-four.f17b2674.png";